import React from "react";
import styled from "styled-components";
import SnsButton from "../../core/Button/SnsButton";

const Contact = () => {
  return (
    <StyledContainer className="landing__contact">
      <Header>Contact us</Header>
      <Content>
        <div className="name">SpaceMap Inc.</div>
        <span>
          <a href="mailto:contact@spacemap42.com" className="email">
            contact@spacemap42.com
          </a>
        </span>
        <address className="address">
          #1103, ITBT, 222 Wangsimni-ro, Seongdong-gu, Seoul, Korea, 04763
        </address>
      </Content>
      {/* <SNS>
        <SnsButton
          link="https://www.facebook.com/SpaceMap42"
          img="/svg/facebook-white.svg"
        />
        <SnsButton
          link="https://www.linkedin.com/company/spacemap42"
          img="/svg/linkedIn-white.svg"
        />
      </SNS>
      <Footer>
        <nav>Terms of Use</nav>
        <nav>Privacy Policy</nav>
      </Footer> */}
    </StyledContainer>
  );
};

export default Contact;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  color: #e9e9e9;
`;

const Header = styled.h1`
  font-size: 1.7rem;
  color: #fccb15;
  margin: 0;
  margin-bottom: 1rem;
`;

const Content = styled.main`
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  gap: 0.7rem;
  > .name {
    font-weight: 700;
    font-size: 1.2rem;
  }
  .email {
    text-decoration: none;
    color: #e9e9e9;
  }
`;

const SNS = styled.nav`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
`;

const Footer = styled.footer`
  display: flex;
  font-size: 0.9rem;
  > nav {
    padding-right: 1rem;
    &:not(:first-child) {
      border-left: 1px solid white;
      padding-left: 1rem;
    }
  }
`;
